import {
  USE_CASE,
  USER_ROLE,
} from '@trustero/trustero-api-web/lib/account/account_pb'

export enum LoginProviders {
  GOOGLE = 'Google',
  AUTH0 = 'Auth0', //Auth0 was acquired by Okta
  OKTA = 'Okta',
  ONELOGIN = 'OneLogin',
  MICROSOFT = 'Microsoft',
  ENTRA = 'Entra',
  PINGONE = 'PingOne',
  PINGONE_TRUSTERO = 'pingone-trustero',
  PINGONE_NAFINC = 'pingone-nafinc',
  ENTRAIDSSO = 'Enterprise SSO',
  ENTRAID_TRUSTERO = 'entraid-trustero',
  ENTRAID_CHANEL = 'entraid-chanel',
  ENTRAID_ASSURA = 'entraid-assura',
  ENTRAID_TRUSTERODEV = 'entraid-trusterodev',
}

export type AuthorizationComponentProps = {
  login: ({
    accessToken,
    accountId,
    email,
    useCase,
  }: {
    accessToken: string
    accountId?: string
    email?: string
    redirectUrl: string
    useCase: USE_CASE
    role: USER_ROLE
  }) => void
  setErrorMsg?: React.Dispatch<React.SetStateAction<string>>
  setIsRedirecting?: React.Dispatch<React.SetStateAction<boolean>>
}
